import React, { Component } from "react";
import InfoDialogBaseView from "../../../../components/InfoDialogBase/InfoDialogBaseView";
import InfoDialogTitleView from "../../../../components/InfoDialogBase/InfoDialogTitle/InfoDialogTitleView";
import InfoDialogSubtitleView from "../../../../components/InfoDialogBase/InfoDialogSubtitle/InfoDialogSubtitleView";
import InfoDialogTextView from "../../../../components/InfoDialogBase/InfoDialogText/InfoDialogTextView";
import TranslationView from "../../../../../../components/translation/TranslationView";

export default class CheckCancellationConfirmationView extends Component {

    render() {
        return (
            <InfoDialogBaseView>
                <InfoDialogTitleView>
                    <TranslationView style={{ fontWeight: 300 }}>
                        checkCancelConfirmation
                    </TranslationView>
                </InfoDialogTitleView>

                <InfoDialogSubtitleView>
                    <TranslationView style={{ fontWeight: 500 }}>
                        requestSent
                    </TranslationView>
                </InfoDialogSubtitleView>

                <InfoDialogTextView>
                    <TranslationView style={{ fontWeight: 300 }}>
                        mailWhenCancelComplete
                    </TranslationView>
                </InfoDialogTextView>
            </InfoDialogBaseView>
        );
    }
}